// TODO: If using this function for a method, use it inside the mutation/action
// instead of using it whenever you call the method
export default (objectToClone) => JSON.parse(JSON.stringify(objectToClone));
